module.exports = __webpack_public_path__ + "img/facebook-svgrepo-com.2ed17a73.svg";